import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { BookOpen, Zap, AlertTriangle, Calculator, FileText, Package, Info, ChevronDown, ChevronRight } from 'lucide-react';

/**
 * Guide complet Admin — explique CHAQUE fonctionnalité en langage simple.
 * Structuré en sections accordéon pour navigation facile.
 */

const sections = [
  {
    id: 'catalog',
    icon: <Package className="w-5 h-5 text-indigo-600" />,
    title: 'Catalogue Prix Travaux',
    color: 'indigo',
    items: [
      { q: "Qu'est-ce que c'est ?", a: "Une base interne de 277 produits (peinture, fenêtres, plomberie…) avec prix Fourniture + Pose. Utilisé par l'expert via l'autocomplétion dans son dashboard — il tape 2 lettres et obtient la suggestion avec prix préconfiguré." },
      { q: "Fourniture vs Pose vs Total vs Détaillé", a: "L'expert a 4 boutons sur chaque produit : 🛒 Fourniture (matériel seul), 🔨 Pose (main d'œuvre seule), 📦 Total (F+P sur 1 ligne), 📋 Détaillé (2 lignes séparées)." },
      { q: "À quoi sert le champ Notes internes ?", a: "Réservé UNIQUEMENT à vous (Admin). Permet d'écrire vos marges, contacts fournisseurs, astuces. JAMAIS visible par l'expert ou le client." },
      { q: "Fiche PDF auto vs Officielle", a: "🤖 Auto = générée par le système avec votre logo (instantané). 📎 Officielle = vraie fiche constructeur que vous uploadez depuis le site du fabricant (Schüco, Daikin…)." },
      { q: 'Bouton "🤖 Fiches auto (produits sans PDF)"', a: "Génère en 1 clic les fiches auto pour TOUS les produits qui n'ont pas encore de PDF. NE TOUCHE PAS les fiches officielles uploadées. NE RECRÉE PAS les auto existantes." },
      { q: "Prix marché d'où viennent-ils ?", a: "Base manuelle établie à partir des prix moyens France 2024-2025 (Batiprix, Leroy Merlin, Castorama, Point P). À ajuster selon votre région via Modifier." },
    ],
  },
  {
    id: 'expert',
    icon: <FileText className="w-5 h-5 text-emerald-600" />,
    title: 'Dashboard Expert (sur le terrain)',
    color: 'emerald',
    items: [
      { q: "4 modes d'ajout produit", a: "Sur chaque suggestion : 🛒 Fourniture, 🔨 Pose, 📦 Total, 📋 Détaillé. Le PDF fiche est joint UNIQUEMENT sur les modes qui incluent le matériel (pas sur Pose seule = main d'œuvre)." },
      { q: "Envoyer le devis au client", a: "Bouton 📧 envoie par email : 1) le PDF devis principal avec votre marque + 2) toutes les fiches PDF des produits (si case Joindre cochée). 1 email, tous les documents en un clic." },
      { q: "Checkbox 'Joindre les fiches PDF'", a: "Si cochée : le client reçoit toutes les fiches techniques des produits du devis. Affiche en temps réel combien seront jointes (ex: '3 disponibles')." },
      { q: "Alertes Réglementaires", a: "Bloc 🚨 qui analyse automatiquement : DPE, année de construction, adresse. Déclenche des alertes rouges/oranges/vertes selon : location interdite, diagnostic obligatoire, zone PPRI, sismique, argile…" },
      { q: "Simulation Financière", a: "Calcule 2 scénarios : Revente (ROI, plus-value, fiscalité adaptée au profil) + Location LD (cashflow, rentabilité). Adapté automatiquement selon Particulier / SCI IR / SCI IS / Marchand de Biens." },
    ],
  },
  {
    id: 'regulatory',
    icon: <AlertTriangle className="w-5 h-5 text-red-600" />,
    title: 'Alertes Réglementaires — Base Juridique',
    color: 'red',
    items: [
      { q: 'DPE F = décote -12%', a: "Depuis 2023, si DPE F : audit énergétique réglementaire obligatoire (~850€). Depuis 2028, le F sera interdit à la location. Donc le marché applique une décote de -10 à -15% sur un bien F." },
      { q: 'DPE G = location interdite immédiate', a: "Depuis 01/01/2025, un bien classé G ne peut plus être MIS EN LOCATION (renouvellements OK). Décote marché -15 à -20%. Argument majeur en négociation achat pour un MDB." },
      { q: 'DPE E = anticipation', a: "Audit énergétique obligatoire depuis 01/01/2025. Interdiction location à partir de 2034. Décote commence à se faire sentir (-5 à -8%)." },
      { q: "Construit avant 1949 → Plomb", a: "CREP (Constat de Risque d'Exposition au Plomb) obligatoire. Coût ~120€. Si présence de plomb : travaux encapsulage ou dépose obligatoires." },
      { q: "Construit avant 1997 → Amiante", a: "Diagnostic amiante obligatoire à la vente. Si amiante détecté : dépose par entreprise certifiée SS4 = surcoût important." },
      { q: 'PPRI (Plan de Prévention Risque Inondation)', a: "Zone inondable : surprime assurance +30 à +50%, parfois refus d'assurance. Travaux anti-crue imposés (batardeaux, surélévation prises). Récupéré automatiquement via GeoRisques.gouv.fr." },
      { q: 'Zone sismique ≥ 3', a: "France divisée en 5 zones. Zones 3-4-5 imposent études parasismiques G2 + structures adaptées. Coût étude : 1 500 à 3 000€." },
      { q: 'Retrait-gonflement argiles', a: "Loi ELAN (2020) : étude géotechnique G2 AVP obligatoire dans zones argileuses pour construction/extension. Coût ~2 800€. Sinon : fissures graves 5-10 ans après construction." },
      { q: 'Périmètre Monuments Historiques (ABF)', a: "Rayon 500m autour d'un MH classé → tous travaux visibles depuis MH soumis à l'avis ABF (Architecte des Bâtiments de France). Délai +2 à 4 mois. Matériaux et couleurs imposés." },
    ],
  },
  {
    id: 'fiscal',
    icon: <Calculator className="w-5 h-5 text-amber-600" />,
    title: 'Fiscalité selon Profil (Particulier / SCI / MDB)',
    color: 'amber',
    items: [
      { q: '🏠 Particulier', a: "Plus-value immobilière 36,2% (19% IR + 17,2% PS). Abattement progressif : 0% avant 6 ans, 100% après 22 ans (IR) et 30 ans (PS). MaPrimeRénov' accessible si résidence principale." },
      { q: '🏛️ SCI IR (transparente)', a: "Même régime que Particulier (plus-value immo). Utile pour patrimoine familial, transmission, pas de TVA sur marge. Pas de MaPrimeRénov'." },
      { q: '🏛️ SCI IS (Impôt Société)', a: "IS 15% sur les premiers 42 500€ de bénéfice, 25% au-delà. Avantage : amortissement du bien déductible. Inconvénient : double imposition à la cession (IS + distribution)." },
      { q: '🏢 Marchand de Biens (MDB)', a: "Régime spécifique : TVA sur marge à la revente + IS sur résultat. Frais notaire réduits à 2,5% (au lieu de 7-8%). Revente obligatoire < 5 ans sinon requalification fiscale. Dommage-Ouvrage obligatoire." },
      { q: 'TVA sur marge MDB : 2 cas', a: "1) Acquis auprès d'un assujetti TVA (promoteur/MDB) : TVA 20% sur la MARGE seulement. 2) Acquis auprès d'un particulier : TVA 20% sur le PRIX TOTAL (bien plus pénalisant). Le champ du dashboard permet de basculer entre les 2 modes." },
    ],
  },
  {
    id: 'documents',
    icon: <FileText className="w-5 h-5 text-blue-600" />,
    title: 'Documents obligatoires à la vente (DDT)',
    color: 'blue',
    items: [
      { q: 'DPE', a: "Diagnostic Performance Énergétique. OBLIGATOIRE pour toute vente. Coût 100-250€ selon surface. Valable 10 ans. Sans DPE = vente annulable." },
      { q: 'Audit énergétique réglementaire', a: "Obligatoire si DPE F ou G depuis 01/04/2023 (E depuis 01/01/2025). Coût 500-1000€. Contient plan de travaux chiffré en 2 scénarios." },
      { q: 'ERP — État des Risques et Pollutions', a: "Obligatoire dans toutes les communes concernées par un risque. Coût ~30€. Valable 6 mois. Détaille PPRI, PPRT, sismique, radon." },
      { q: 'Loi Carrez', a: "Mesurage surface privative obligatoire en copropriété. Coût ~100€. Écart >5% = acquéreur peut demander une baisse de prix." },
      { q: 'Pack diagnostics complet', a: "DPE + Amiante + Plomb + Élec + Gaz + ERP + Termites + Carrez. Négocié groupé : 400-800€ au lieu de 1 200€ séparés. Produit disponible dans votre catalogue." },
    ],
  },
  {
    id: 'aides',
    icon: <Zap className="w-5 h-5 text-teal-600" />,
    title: 'MaPrimeRénov & Aides (enrichissement audit)',
    color: 'teal',
    items: [
      { q: 'Les 4 tranches de revenus (2025)', a: "🔵 Bleu = Très modeste (RFR ≤ 17 009€ 1 pers) → aides max 80%. 🟡 Jaune = Modeste (≤ 20 593€) → aides 60-80%. 🟣 Violet = Intermédiaire (≤ 28 657€) → aides 45-50%. 🌸 Rose = Supérieur → aides 10-30%." },
      { q: 'Parcours Accompagné vs Par geste', a: "Parcours Accompagné (rénovation d'ampleur, gain DPE ≥ 2 classes) = aides majorées. Parcours Par geste (1 seul travaux, gain DPE = 1 classe) = aides réduites. Le système choisit auto selon le DPE avant/après." },
      { q: "Bonus sortie passoire énergétique", a: "Si le bien était F ou G et devient D ou mieux après travaux → bonus 1 500€ (ménages très modestes/modestes) ou 500€ (autres)." },
      { q: 'Plafond de travaux MaPrimeRénov', a: "40 000€ (<70m²), 55 000€ (70-130m²), 70 000€ (>130m²). Majoré de 50% si gain DPE ≥ 4 classes." },
      { q: 'Éco-PTZ cumulable', a: "Prêt à taux zéro jusqu'à 50 000€ pour financer les travaux énergétiques. Cumulable avec MaPrimeRénov'. Remboursable sur 20 ans max." },
      { q: 'Qui est éligible ?', a: "Propriétaire occupant OU bailleur. Résidence principale du locataire > 8 mois/an. Logement construit depuis + 15 ans. NON éligible pour MDB (pas résidence principale)." },
    ],
  },
  {
    id: 'environment',
    icon: <Zap className="w-5 h-5 text-sky-600" />,
    title: 'Environnement local (OSM + INSEE)',
    color: 'sky',
    items: [
      { q: 'Écoles à proximité', a: "Via Overpass OSM (OpenStreetMap), recherche des écoles primaires, collèges, lycées dans un rayon de 800m. Affiche nombre + distance de la plus proche. Argument vente familles." },
      { q: 'Gares et transports', a: "Gares SNCF/RER dans un rayon 2km + arrêts bus à 800m. Un bien à <5min d'une gare se vend 10 à 15% plus cher (source INSEE)." },
      { q: 'Commerces de proximité', a: "Supermarchés, boulangeries, épiceries dans un rayon 800m. Plus il y en a, plus le quartier est attractif." },
      { q: "À quoi ça sert ?", a: "Donne des arguments de vente mesurables au moment où vous chiffrez le bien. Le client particulier retient davantage des chiffres concrets qu'un 'quartier sympa'." },
    ],
  },
  {
    id: 'obligations',
    icon: <AlertTriangle className="w-5 h-5 text-orange-600" />,
    title: 'Checklist Obligations automatique',
    color: 'amber',
    items: [
      { q: 'Déclaration Préalable (DP) vs Permis de Construire (PC)', a: "DP si travaux < 20m² ou modif façade. PC si extension/création > 20m² (40m² en zone U avec PLU). Au-delà de 150m² : architecte obligatoire." },
      { q: 'Attestation Consuel', a: "Obligatoire pour toute installation électrique neuve ou rénovée avant remise en service par Enedis. Coût ~120€. Sans elle = pas de courant." },
      { q: 'Autorisation syndic / AG copropriété', a: "Tout travaux affectant parties communes ou aspect extérieur → vote préalable en Assemblée Générale. Compter délai 2-6 mois selon calendrier AG." },
      { q: 'Dommage-Ouvrage (MDB)', a: "Obligatoire pour le MDB qui réalise des travaux soumis à la garantie décennale. 2-3% du coût travaux. Sans DO = responsabilité personnelle du MDB si sinistre." },
      { q: 'RC Pro Marchand de Biens', a: "Responsabilité civile professionnelle obligatoire. ~500-800€/an. Couvre les conséquences de votre activité (erreurs, oublis, litiges)." },
      { q: 'DT-DICT avant travaux extérieurs', a: "Déclaration de Travaux aux exploitants de réseaux enterrés (gaz, élec, télécom, eau). Gratuit. Obligatoire avant fouille. Sans ça = amende + responsabilité si dégâts réseaux." },
    ],
  },
  {
    id: 'dvf',
    icon: <Zap className="w-5 h-5 text-purple-600" />,
    title: 'DVF Enrichi — Analyse marché secteur',
    color: 'purple',
    items: [
      { q: 'Ventes analysées', a: "Nombre de transactions réelles DVF (Demande de Valeurs Foncières) dans le secteur récupérées sur data.economie.gouv.fr. Plus il y en a, plus l'estimation est fiable." },
      { q: 'Prix m² moyen vs médian', a: "Moyenne = sensible aux extrêmes. Médiane = valeur centrale plus représentative. Se baser sur la médiane pour une estimation réaliste." },
      { q: "Fourchette min-max (écart prix)", a: "Indique la dispersion des prix. Écart < 30% → marché homogène (prix fiables). Écart > 60% → secteur hétérogène (attention aux comparaisons hâtives)." },
      { q: 'Tension marché', a: "Calculée sur l'écart prix : Faible (<30%) = marché stable. Modérée (30-60%) = vente OK. Forte (>60%) = marché hétérogène ou en transition." },
    ],
  },
  {
    id: 'workflow',
    icon: <Zap className="w-5 h-5 text-indigo-600" />,
    title: 'Workflow complet : du prospect à la vente',
    color: 'indigo',
    items: [
      { q: 'ÉTAPE 1 — Radar Foncier', a: "Client prospect : code RAD-2026-XXXXX + email. Les données DVF (10 dernières ventes) sont affichées en ligne. Envoi d'un rapport PDF par email." },
      { q: 'ÉTAPE 2 — Estimation', a: "Expert estime le bien avec coefficients dynamiques (modifiables dans l'onglet Coefficients Estimation). Score /100 calculé automatiquement." },
      { q: 'ÉTAPE 3 — Conseil Stratégique VIP', a: "Paiement Stripe 850€ (modifiable). Code CON-2026-XXXXX + RDV interne via calendrier (/conseil/rdv). Facture PDF envoyée auto + rappel 24h avant." },
      { q: 'ÉTAPE 4 — Audit Expert / Chantier', a: "Expert remplit son dashboard avec : travaux (catalogue), alertes réglementaires, scénarios financiers, enrichissement audit (MaPrimeRénov, environnement, obligations, DVF). Envoi devis client avec fiches PDF en 1 clic." },
      { q: 'ÉTAPE 5 — Suivi dossier', a: "Le client peut suivre son dossier via son code (RAD ou CON) sans se créer de compte. Modal de suivi accessible depuis la page d'accueil." },
    ],
  },
  {
    id: 'geocoding',
    icon: <Zap className="w-5 h-5 text-rose-600" />,
    title: 'Géocodage automatique des projets (GPS)',
    color: 'rose',
    items: [
      { q: 'Pourquoi c\'est important ?', a: "Les modules Environnement (écoles, gares, bus, commerces) et Alertes Réglementaires (zone PPRI, sismique, argile) nécessitent des coordonnées GPS (latitude/longitude) pour interroger les bases publiques." },
      { q: 'Comment ça fonctionne ?', a: "Quand l'expert clique sur 'Enrichir l'audit' dans son Dashboard, le système vérifie si le dossier a déjà des coordonnées GPS. Si non, il interroge api-adresse.data.gouv.fr avec l'adresse du bien, récupère lat/lon et les PERSISTE en base. Plus besoin de refaire." },
      { q: 'Source officielle', a: "API Adresse de l'État (api-adresse.data.gouv.fr). Gratuite, officielle, sans limite de requêtes. Même base que La Poste et le cadastre." },
      { q: 'Si le géocodage échoue ?', a: "Rare, mais si l'adresse est trop imprécise ou erronée : les coordonnées restent vides et les modules OSM affichent 'Coordonnées GPS manquantes'. Corriger l'adresse du dossier résout le problème." },
    ],
  },
  {
    id: 'loan-rates',
    icon: <Zap className="w-5 h-5 text-violet-600" />,
    title: 'Taux crédit auto (Meilleurtaux scraping)',
    color: 'violet',
    items: [
      { q: 'Scraping hebdomadaire', a: "Chaque semaine, le système va scraper le baromètre des taux de Meilleurtaux et met à jour les taux 15/20/25 ans en base. Si le scraping échoue, les valeurs précédentes sont conservées (jamais de perte)." },
      { q: 'Tab Admin \"Taux Crédit\"', a: "Dans la sidebar Admin. Vous pouvez : voir la dernière MAJ + la source (auto Meilleurtaux ou manuel Admin), saisir vos propres taux (utile si info privilégiée courtier), recharger la vue, enregistrer." },
      { q: 'Utilisation par l\'Expert', a: "Le champ 'Taux crédit %' de la carte 💰 Simulation Financière du Dashboard Expert est pré-rempli avec le taux 20 ans actuel. L'expert peut toujours le surcharger dossier par dossier." },
      { q: 'Fréquence de refresh', a: "Loop asynchrone toutes les 7 jours × 24h × 3600s. Au premier démarrage du backend, tentative immédiate. Puis toutes les semaines." },
      { q: 'Source de vérité', a: "Meilleurtaux.com/credit-immobilier/barometre-des-taux.html (site public). Extraction par regex robuste (ne casse pas si la page change légèrement)." },
    ],
  },
  {
    id: 'audit-report',
    icon: <FileText className="w-5 h-5 text-cyan-600" />,
    title: 'Rapport Audit Complet (PDF 5 pages)',
    color: 'cyan',
    items: [
      { q: 'Qu\'est-ce que c\'est ?', a: "Un document PDF premium de 5 pages à l'image de votre marque, compilant TOUT ce qui a été analysé sur un dossier : alertes réglementaires, scénarios financiers, aides MaPrimeRénov', environnement, DVF, chiffrage travaux, synthèse." },
      { q: 'Où le générer ?', a: "Dans le Dashboard Expert, une fois un dossier sélectionné → bouton '📄 Rapport audit complet' (indigo) à côté des boutons 'Valider le dossier' et 'PDF simple'." },
      { q: 'Prérequis', a: "Pour que l'enrichissement (MaPrimeRénov', environnement, DVF) apparaisse dans le PDF, l'expert DOIT avoir cliqué sur '🚀 Enrichir l\\'audit' au moins une fois avant de générer le rapport. Les alertes réglementaires et scénarios sont recalculés à chaque génération." },
      { q: 'Structure du PDF', a: "Page 1 = Couverture + sommaire. Page 2 = Alertes + obligations. Page 3 = Scénarios Revente/Location. Page 4 = MPR + Environnement + DVF. Page 5 = Travaux + synthèse + disclaimer légal." },
      { q: 'Monétisation potentielle', a: "Ce rapport peut être vendu 150-250€ en upsell après le Conseil Stratégique. Il justifie sa valeur : 5 pages analytiques, données officielles (ADEME, GeoRisques, DVF, INSEE, OSM), calculs fiscaux adaptés au profil du client." },
    ],
  },
];

const colorMap = {
  indigo: 'bg-indigo-50 border-indigo-200',
  emerald: 'bg-emerald-50 border-emerald-200',
  red: 'bg-red-50 border-red-200',
  amber: 'bg-amber-50 border-amber-200',
  blue: 'bg-blue-50 border-blue-200',
  purple: 'bg-purple-50 border-purple-200',
  teal: 'bg-teal-50 border-teal-200',
  sky: 'bg-sky-50 border-sky-200',
  rose: 'bg-rose-50 border-rose-200',
  violet: 'bg-violet-50 border-violet-200',
  cyan: 'bg-cyan-50 border-cyan-200',
};

export default function GuideCompletTab() {
  const [openSection, setOpenSection] = useState('catalog');

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <BookOpen className="w-6 h-6 text-indigo-700" />
          Guide Complet — Comprendre votre système
        </CardTitle>
        <p className="text-sm text-gray-600 mt-1">
          Chaque fonctionnalité expliquée simplement. Cliquez sur une section pour la déplier.
        </p>
      </CardHeader>
      <CardContent className="space-y-2">
        <div className="bg-gradient-to-r from-indigo-50 to-purple-50 border border-indigo-200 rounded-lg p-3 mb-4 flex items-start gap-2">
          <Info className="w-5 h-5 text-indigo-700 flex-shrink-0 mt-0.5" />
          <div className="text-sm text-indigo-900">
            <b>À garder à portée</b> — Cette page regroupe toutes les explications métier, règlementaires et techniques de votre système.
            Utilisez-la comme référence quand un employé ou un collaborateur vous pose une question.
          </div>
        </div>

        {sections.map((section) => (
          <div key={section.id} className={`rounded-lg border ${colorMap[section.color]} overflow-hidden`} data-testid={`guide-section-${section.id}`}>
            <button
              type="button"
              onClick={() => setOpenSection(openSection === section.id ? null : section.id)}
              className="w-full flex items-center justify-between gap-3 px-4 py-3 hover:bg-white/50 transition"
              data-testid={`guide-toggle-${section.id}`}
            >
              <div className="flex items-center gap-3">
                {section.icon}
                <span className="font-semibold text-navy">{section.title}</span>
                <span className="text-xs text-gray-500">({section.items.length} points)</span>
              </div>
              {openSection === section.id ? <ChevronDown className="w-5 h-5 text-gray-500" /> : <ChevronRight className="w-5 h-5 text-gray-500" />}
            </button>
            {openSection === section.id && (
              <div className="px-4 pb-4 space-y-3 bg-white/70">
                {section.items.map((item, i) => (
                  <div key={i} className="bg-white rounded border border-gray-200 p-3">
                    <div className="font-semibold text-navy text-sm flex items-start gap-2">
                      <span className="text-gold">▸</span>
                      {item.q}
                    </div>
                    <div className="text-sm text-gray-700 mt-1 pl-5 leading-relaxed">{item.a}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}

        <div className="mt-6 bg-amber-50 border border-amber-300 rounded-lg p-4">
          <div className="flex items-start gap-2">
            <Info className="w-5 h-5 text-amber-700 flex-shrink-0 mt-0.5" />
            <div>
              <div className="font-semibold text-amber-900">Sources publiques utilisées par le système</div>
              <ul className="text-sm text-amber-800 mt-2 space-y-1 list-disc list-inside">
                <li><b>ADEME</b> (data.ademe.fr) — base officielle des DPE</li>
                <li><b>GeoRisques.gouv.fr</b> — PPRI, sismique, argile, radon, pollutions</li>
                <li><b>API Adresse</b> (api-adresse.data.gouv.fr) — géocodage + code INSEE</li>
                <li><b>API Cadastre IGN</b> — parcelles, zonage PLU</li>
                <li><b>DVF</b> (data.economie.gouv.fr) — 10 dernières ventes</li>
              </ul>
              <p className="text-xs text-amber-700 mt-2 italic">
                Toutes les données publiques sont récupérées en temps réel, gratuitement, via les API officielles de l'État français.
              </p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
